import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import './css/home.scss'

export default class Home extends Component {
    host = () => { 
            this.props.history.push('/createGame/')    }
    render() {
                    
        return (
            <div className="containThis welcome">
                 <h1>welcome to nakbah</h1> 

                 <Button onClick={this.host} variant="outline-success" style={{width:'100%',fontSize:'30px'}}>host game</Button>
            </div>
        )
    }
}
